import React from 'react';
import { RecommendationBar } from '../../../components/Shared';
import GenericSection from '../../../components/GenericSection';
import { MoreOptionsSection } from '../../../components/MoreOptions';
import { AdvertisementCiting } from '../../../components/citing/AdvertisementCiting';
import { TabHeaders } from '../constants';
import { ONLINE_PUBINFO_SECTION_FIELDS } from '../constants/fieldList/online';
import { PubMainTypeEnum } from '../../../types';
var Online = function Online() {
  var ONLINE_SECTION_TITLE_TEST_ID = 'online-pub-section-test-id';
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(RecommendationBar, null), /*#__PURE__*/React.createElement(AdvertisementCiting, null), /*#__PURE__*/React.createElement(GenericSection, {
    name: PubMainTypeEnum.PUB_ONLINE,
    sectionTitle: "Online publication info",
    fieldList: ONLINE_PUBINFO_SECTION_FIELDS,
    "data-test": ONLINE_SECTION_TITLE_TEST_ID,
    selectedTab: TabHeaders.ONLINE
  }), /*#__PURE__*/React.createElement(MoreOptionsSection, null));
};
export default Online;